var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwikLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 34,
    viewBox: "0 0 132 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0004 0C40.0493 0 46.2691 4.50644 46.2692 12.7146C46.2692 18.7903 43.7486 23.7397 39.5208 26.677L42.2042 29.4131L37.2037 34L32.8948 29.3325C31.7973 29.5337 30.6183 29.6545 29.4394 29.6545C23.2104 29.6545 17.8812 26.6969 16.0516 21.3311L4.1578 18.2036H15.4184C15.418 18.1986 15.4175 18.1936 15.4171 18.1885H19.4046L15.509 14.6852C15.561 14.2336 15.628 13.7894 15.7093 13.3529L0 9.05397H21.693L18.7157 6.32864C21.6553 2.38159 26.3425 1.43218e-05 32.0004 0ZM31.7565 6.43769C26.6751 6.39745 24.0327 11.3871 24.0327 16.7386C24.0328 19.4343 25.049 21.6472 27.0814 22.7336L31.919 18.7907L34.6023 21.5669C36.5942 19.6757 37.6104 16.497 37.6105 12.9965C37.6105 9.45567 35.8217 6.47792 31.7565 6.43769Z",
    fill: "url(#paint0_linear_85_331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1421 18.67L65.1339 0.402571H72.1666L73.7926 18.8307L80.622 0.402571H88.3053L76.7198 29.1713H68.5488L66.8818 11.6284L59.7272 29.1713H51.3123L48.8733 0.402571H57.3286L58.1421 18.67Z",
    fill: "url(#paint1_linear_85_331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4325 29.1713H87.0176L91.6113 0.402571H100.026L95.4325 29.1713Z",
    fill: "url(#paint2_linear_85_331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.325 11.8297L123.057 0.402571H132L118.829 14.1633L127.488 29.1713H118.504L111.552 16.658L109.561 29.1713H101.186L105.78 0.402571H114.154L112.325 11.8297Z",
    fill: "url(#paint3_linear_85_331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_331",
    x1: 132,
    y1: 17,
    x2: 0,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85_331",
    x1: 132,
    y1: 17,
    x2: 0,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_85_331",
    x1: 132,
    y1: 17,
    x2: 0,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_85_331",
    x1: 132,
    y1: 17,
    x2: 0,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwikLogo);
export default __webpack_public_path__ + "static/media/Qwik-logo.63d693590669f58e33fadfc4e164c80b.svg";
export { ForwardRef as ReactComponent };